export const COLUMN_COUNT = 5

export const ROW_COUNT = 10
